import { AppRouter } from "./router/AppRouter";
import { ConnectionStatus } from "../components/ui/ConnectionStatus";

export function App() {
  return (
    <>
      <ConnectionStatus />
      <AppRouter />
    </>
  );
}
